export enum E_SmartDisplayGraphType {
    Area = 'Area',
    Candlestick = 'Candlestick',
    BarPercentage = 'BarPercentage',
    Scatter = 'Scatter',
    Bar = 'Bar',
    Line = 'Line',
    Marker = 'Marker',
    MarkArea = 'MarkArea',
    Balance = 'Balance'
}
